import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Offers.css";
import { useDispatch } from "react-redux";
import {
  onAllProducts,
  onCategoriesList,
  onOfersAdd,
  onOfersEdit,
} from "../../redux/homeAction";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useLocation, useNavigate } from "react-router-dom";

const TITLE_OPTIONS = [
  { value: "End of Reason Sale (EORS)", label: "End of Reason Sale (EORS)" },
  { value: "Flat 50% OFF", label: "Flat 50% OFF" },
  { value: "Buy 1 Get 1 Free", label: "Buy 1 Get 1 Free" },
  { value: "Mega Blockbuster Sale", label: "Mega Blockbuster Sale" },
  {
    value: "Flat ₹500 OFF on First Order",
    label: "Flat ₹500 OFF on First Order",
  },
  { value: "Clearance Sale", label: "Clearance Sale" },
  { value: "Deal of the Day", label: "Deal of the Day" },
  { value: "Weekend Bonanza", label: "Weekend Bonanza" },
];

const DEFAULT_TAG_OPTIONS = [
  { value: "summer", label: "Summer" },
  { value: "winter", label: "Winter" },
  { value: "clearance", label: "Clearance" },
  { value: "festive", label: "Festive" },
];

function OffersAdd({ initialData = null }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const jsonData = state;

  const [titleSelected, setTitleSelected] = useState(null);
  const [loader, setLoader] = useState(false);
  const [description, setDescription] = useState("");
  const [offerType, setOfferType] = useState("percentage");
  const [offerValue, setOfferValue] = useState("");
  const [buy, setBuy] = useState(1);
  const [get, setGet] = useState(1);

  // Backend support ke sath Perfect Slab State Structure
  const [percentageSlabs, setPercentageSlabs] = useState([
    { minSpend: "", discountPercent: "" },
  ]);

  const [applicableProductsSelected, setApplicableProductsSelected] = useState(
    [],
  );
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [applicableTagsSelected, setApplicableTagsSelected] = useState([]);
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const data = jsonData?.productId || initialData;

    if (data) {
      if (data.title) {
        setTitleSelected({ value: data.title, label: data.title });
      } else {
        setTitleSelected(null);
      }

      setDescription(data.description || "");
      setOfferType(data.offerType || "percentage");

      if (data.offerType === "bogo" || data.offerType === "buyXgetY") {
        if (data.offerValue && typeof data.offerValue === "object") {
          setBuy(data.offerValue.buy || 1);
          setGet(data.offerValue.get || 1);
        }
      } else if (data.offerType === "percentageSlab") {
        // Edit mode me agar slabs array object ke andar hain to use map karein
        if (data.offerValue && Array.isArray(data.offerValue.slabs)) {
          setPercentageSlabs(data.offerValue.slabs);
        } else if (Array.isArray(data.offerValue)) {
          setPercentageSlabs(data.offerValue);
        } else {
          setPercentageSlabs([{ minSpend: "", discountPercent: "" }]);
        }
      } else {
        setOfferValue(data.offerValue || "");
      }

      const options = (data.applicableProducts || []).map((p) => ({
        value: p._id,
        label: p.name,
      }));
      setApplicableProductsSelected(options);

      const categoryOptions = (data.applicableCategories || []).map((c) => ({
        value: c?._id,
        label: c?.name,
      }));
      setSelectedCategories(categoryOptions);

      const tagOptions = (data.applicableTags || []).map((tag) => ({
        value: tag.toLowerCase(),
        label: tag,
      }));
      setApplicableTagsSelected(tagOptions);

      setActiveFrom(data.activeFrom ? data.activeFrom.slice(0, 10) : "");
      setActiveTo(data.activeTo ? data.activeTo.slice(0, 10) : "");
    }
  }, [initialData, jsonData]);

  useEffect(() => {
    dispatch(onAllProducts(setProducts));
    dispatch(onCategoriesList(setCategories));
  }, [dispatch]);

  const disableNumberScroll = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  // Dynamic Validation Engine
  function validate() {
    const err = {};
    if (!titleSelected || !titleSelected.value.trim())
      err.title = "Title is required";
    if (!offerType) err.offerType = "Offer type required";

    if (offerType === "percentage") {
      const v = Number(offerValue);
      if (!v || v <= 0 || v > 100) err.offerValue = "Enter percentage (1-100)";
    }
    if (offerType === "flat") {
      const v = Number(offerValue);
      if (!v || v <= 0) err.offerValue = "Enter flat amount (>0)";
    }
    if (offerType === "bogo" || offerType === "buyXgetY") {
      if (!buy || Number(buy) <= 0) err.buy = "Buy must be > 0";
      if (!get || Number(get) <= 0) err.get = "Get must be > 0";
    }
    if (offerType === "percentageSlab") {
      percentageSlabs.forEach((s, idx) => {
        if (!s.minSpend || Number(s.minSpend) <= 0) {
          err[`slab_min_${idx}`] = "Enter valid min spend";
        }
        if (
          !s.discountPercent ||
          Number(s.discountPercent) <= 0 ||
          Number(s.discountPercent) > 100
        ) {
          err[`slab_percent_${idx}`] = "Percent must be 1-100";
        }
      });
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;

    let valueToSave = null;
    switch (offerType) {
      case "percentage":
      case "flat":
        valueToSave = Number(offerValue);
        break;
      case "bogo":
      case "buyXgetY":
        valueToSave = { buy: Number(buy), get: Number(get) };
        break;
      case "percentageSlab":
        // Backend key matching {"slabs": [{minSpend, discountPercent}]}
        valueToSave = {
          slabs: percentageSlabs.map((s) => ({
            minSpend: Number(s.minSpend),
            discountPercent: Number(s.discountPercent),
          })),
        };
        break;
      default:
        valueToSave = offerValue;
    }

    const payload = {
      title: titleSelected.value.trim(),
      description: description.trim(),
      offerType,
      offerValue: valueToSave,
      applicableProducts: applicableProductsSelected.map((opt) => opt.value),
      applicableCategories: selectedCategories.map((item) => item.value),
      applicableTags: applicableTagsSelected.map((opt) => opt.label.trim()),
      activeFrom: activeFrom ? new Date(activeFrom).toISOString() : null,
      activeTo: activeTo ? new Date(activeTo).toISOString() : null,
    };

    if (jsonData?.type === "edit") {
      dispatch(
        onOfersEdit(setLoader, payload, jsonData?.productId?._id, navigate),
      );
    } else {
      dispatch(onOfersAdd(setLoader, payload, navigate));
    }
  }

  function addSlab() {
    setPercentageSlabs((s) => [...s, { minSpend: "", discountPercent: "" }]);
  }
  function removeSlab(i) {
    if (percentageSlabs.length > 1) {
      setPercentageSlabs((s) => s.filter((_, idx) => idx !== i));
    }
  }

  return (
    <div className="offer-form card shadow-sm col-md-8 mx-auto my-4">
      <div className="card-body">
        <h4 className="card-title mb-4 fw-bold text-primary">
          {jsonData?.type === "edit"
            ? "✏️ Edit Offer Details"
            : "✨ Create New Promotional Offer"}
        </h4>
        <hr />
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Offer Title *</label>
            <CreatableSelect
              isClearable
              options={TITLE_OPTIONS}
              value={titleSelected}
              onChange={(selected) => setTitleSelected(selected)}
              placeholder="Select campaign or type a new one..."
              promptTextCreator={(label) => `Use custom title: "${label}"`}
            />
            {errors.title && (
              <div className="text-danger small mt-1">{errors.title}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">
              Description / Terms
            </label>
            <textarea
              className="form-control"
              rows={2}
              placeholder="Add discount terms or visibility details..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">
              Offer Logic / Type *
            </label>
            <select
              className="form-select"
              value={offerType}
              onChange={(e) => setOfferType(e.target.value)}
            >
              <option value="percentage">Percentage Discount (%)</option>
              <option value="flat">Flat Cash Discount (₹)</option>
              <option value="bogo">BOGO (Buy 1 Get 1 Free)</option>
              <option value="buyXgetY">Custom Buy X Get Y</option>
              <option value="percentageSlab">
                Volume Spend Slabs (Tiered)
              </option>
            </select>
          </div>

          {/* FLAT & PERCENTAGE */}
          {(offerType === "percentage" || offerType === "flat") && (
            <div className="mb-3 card p-3 bg-light">
              <label className="form-label fw-bold">
                {offerType === "percentage"
                  ? "Discount Percentage (%)"
                  : "Flat Discount Amount (₹)"}{" "}
                *
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  {offerType === "percentage" ? "%" : "₹"}
                </span>
                <input
                  type="number"
                  className={`form-control ${errors.offerValue ? "is-invalid" : ""}`}
                  value={offerValue}
                  onChange={(e) => setOfferValue(e.target.value)}
                  placeholder={offerType === "percentage" ? "10" : "500"}
                  onKeyDown={disableNumberScroll}
                  onWheel={(e) => e.target.blur()}
                />
                {errors.offerValue && (
                  <div className="invalid-feedback">{errors.offerValue}</div>
                )}
              </div>
            </div>
          )}

          {/* BOGO & BUY X GET Y */}
          {(offerType === "bogo" || offerType === "buyXgetY") && (
            <div className="mb-3 card p-3 bg-light">
              <label className="form-label fw-bold mb-2">
                Deal Ratio Rules
              </label>
              <div className="row g-3">
                <div className="col-6">
                  <label className="form-label small text-muted">
                    Customer Buys (Qty) *
                  </label>
                  <input
                    type="number"
                    className={`form-control ${errors.buy ? "is-invalid" : ""}`}
                    value={buy}
                    onChange={(e) => setBuy(e.target.value)}
                    onKeyDown={disableNumberScroll}
                    onWheel={(e) => e.target.blur()}
                  />
                  {errors.buy && (
                    <div className="invalid-feedback">{errors.buy}</div>
                  )}
                </div>
                <div className="col-6">
                  <label className="form-label small text-muted">
                    Customer Gets Free (Qty) *
                  </label>
                  <input
                    type="number"
                    className={`form-control ${errors.get ? "is-invalid" : ""}`}
                    value={get}
                    onChange={(e) => setGet(e.target.value)}
                    onKeyDown={disableNumberScroll}
                    onWheel={(e) => e.target.blur()}
                  />
                  {errors.get && (
                    <div className="invalid-feedback">{errors.get}</div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* PERCENTAGE SLAB (SPEND BASED) */}
          {offerType === "percentageSlab" && (
            <div className="mb-3 card p-3 bg-light border-warning">
              <label className="form-label fw-bold text-dark">
                Dynamic Spend Slabs Config
              </label>
              <span className="text-muted d-block small mb-3">
                Setup multi-tier thresholds. Example: Spend ₹1000 get 10% off.
              </span>

              {percentageSlabs.map((s, idx) => (
                <div
                  key={idx}
                  className="row g-2 align-items-center mb-3 pb-2 border-bottom border-white"
                >
                  <div className="col-sm-5">
                    <label className="form-label small mb-1">
                      Minimum Cart Value (₹) *
                    </label>
                    <input
                      type="number"
                      className={`form-control ${errors[`slab_min_${idx}`] ? "is-invalid" : ""}`}
                      placeholder="e.g. 1000"
                      value={s.minSpend}
                      onChange={(e) =>
                        setPercentageSlabs((prev) => {
                          const copy = [...prev];
                          copy[idx].minSpend = e.target.value;
                          return copy;
                        })
                      }
                      onKeyDown={disableNumberScroll}
                      onWheel={(e) => e.target.blur()}
                    />
                    {errors[`slab_min_${idx}`] && (
                      <div className="text-danger small mt-1">
                        {errors[`slab_min_${idx}`]}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-5">
                    <label className="form-label small mb-1">
                      Trigger Discount (%) *
                    </label>
                    <input
                      type="number"
                      className={`form-control ${errors[`slab_percent_${idx}`] ? "is-invalid" : ""}`}
                      placeholder="e.g. 15"
                      value={s.discountPercent}
                      onChange={(e) =>
                        setPercentageSlabs((prev) => {
                          const copy = [...prev];
                          copy[idx].discountPercent = e.target.value;
                          return copy;
                        })
                      }
                      onKeyDown={disableNumberScroll}
                      onWheel={(e) => e.target.blur()}
                    />
                    {errors[`slab_percent_${idx}`] && (
                      <div className="text-danger small mt-1">
                        {errors[`slab_percent_${idx}`]}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-2 text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger w-100"
                      disabled={percentageSlabs.length === 1}
                      onClick={() => removeSlab(idx)}
                    >
                      🗑️
                    </button>
                  </div>
                </div>
              ))}
              <div>
                <button
                  type="button"
                  className="btn btn-sm btn-dark px-3 mt-1"
                  onClick={addSlab}
                >
                  ➕ Add Next Tier Slab
                </button>
              </div>
            </div>
          )}

          <h5
            className="fw-bold mt-4 mb-3 text-secondary text-uppercase small"
            style={{ letterSpacing: "1px" }}
          >
            Target Filters
          </h5>

          <div className="mb-3">
            <label className="form-label fw-semibold">
              Specific Applicable Products
            </label>
            <Select
              options={products}
              isMulti
              value={applicableProductsSelected}
              onChange={(selected) =>
                setApplicableProductsSelected(selected || [])
              }
              placeholder="Search & choose products..."
            />
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                Applicable Categories
              </label>
              <Select
                options={categories}
                isMulti
                value={selectedCategories}
                onChange={(selected) => setSelectedCategories(selected || [])}
                placeholder="Choose catalog sections..."
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                Applicable Collection Tags
              </label>
              <CreatableSelect
                isMulti
                options={DEFAULT_TAG_OPTIONS}
                value={applicableTagsSelected}
                onChange={(selected) =>
                  setApplicableTagsSelected(selected || [])
                }
                placeholder="Select or Create custom tags..."
              />
            </div>
          </div>

          <h5
            className="fw-bold mt-4 mb-3 text-secondary text-uppercase small"
            style={{ letterSpacing: "1px" }}
          >
            Timeline Control
          </h5>

          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                Campaign Start Date
              </label>
              <input
                type="date"
                className="form-control"
                value={activeFrom}
                onChange={(e) => setActiveFrom(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">
                Campaign Expiry Date
              </label>
              <input
                type="date"
                className="form-control"
                value={activeTo}
                onChange={(e) => setActiveTo(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex gap-2 justify-content-end border-top pt-3">
            <button
              type="button"
              className="btn btn-outline-secondary px-4"
              onClick={() => {
                setTitleSelected(null);
                setDescription("");
                setOfferType("percentage");
                setOfferValue("");
                setBuy(1);
                setGet(1);
                setPercentageSlabs([{ minSpend: "", discountPercent: "" }]);
                setApplicableProductsSelected([]);
                setSelectedCategories([]);
                setApplicableTagsSelected([]);
                setActiveFrom("");
                setActiveTo("");
                setErrors({});
              }}
            >
              Reset Form
            </button>
            <button type="submit" className="btn btn-primary px-5 fw-bold">
              {jsonData?.type === "edit" ? "Update Campaign" : "Publish Offer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

OffersAdd.propTypes = {
  initialData: PropTypes.object,
};

export default OffersAdd;
